import { FirebaseOptions } from 'firebase/app';

interface Environment {
  apiBaseUrl: string;
  configBaseUrl: string;
  firebase: FirebaseOptions;
  production: boolean;
}

// Default (development) environment. Replaced by environment.prod.ts in production builds
// via `fileReplacements` in project.json. Note: the Firebase web config is not secret —
// it identifies the project; security is enforced by Firestore/Storage rules and App Check.
export const environment: Environment = {
  apiBaseUrl: 'https://azpctgiiq4.execute-api.eu-north-1.amazonaws.com/api/v1/webapp',
  configBaseUrl: 'https://azpctgiiq4.execute-api.eu-north-1.amazonaws.com/config/api/v1/webapp',
  firebase: {
    apiKey: 'AIzaSyDL-7kq-_jSjMHayNlBgNjX7Ayu3lMJfK0',
    authDomain: 'rent2end-dc814.firebaseapp.com',
    projectId: 'rent2end-dc814',
    storageBucket: 'rent2end-dc814.firebasestorage.app',
  },
  production: false,
};
